const baseUrl = 'http://thermofisher.cad.manage.al-ecs.synconize.cn/api';//线上
// const baseUrl = 'http://101.132.254.160:7130'; //线下

export default baseUrl